import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import UserResetPasswordForm from "../../../forms/user/resetpassword/form";
import * as firebaseUserActions from "../../../actions/firebaseUser";
import * as formNames from "../../../constants/forms";
import { withRouter } from "react-router-dom";
import { withSnackbar } from "notistack";
import { Alert } from "@material-ui/lab";
import { Box } from "@material-ui/core";
import SnackBarUtil from '../../../utils/SnackBarUtil';
import ComponentLoading from "../../../components/ComponentLoading";
import { change } from 'redux-form';
import UrlBuilderUtil from '../../../utils/projectBased/UrlBuilderUtil';
import { NavLink } from "react-router-dom";
import TranslatorUtil from "../../../utils/TranslatorUtil";
import PageHeading from "../../../components/PageHeading";
import Logo from "../../../components/Logo";
const entityFormName = formNames.RESET_PASSWORD_FORM_NAME;


class ResetPassword extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      dataLoading: true
    }
  }

  componentDidMount(){
    Promise.all([
    ]).then(() =>
      this.setState({
        dataLoading: false
      })
      );
  }




  handleResponse = response => {
    const { enqueueSnackbar, history } = this.props;
    if(!SnackBarUtil.isResponseError(response, enqueueSnackbar)){
      var successMessage = TranslatorUtil.t("Email with password recovery link sent.")
      enqueueSnackbar(successMessage, {
        variant: "success"
      });
      history.push('/');
    }
  }

  handleSubmit = values => {
    const { actions } = this.props;
    //has to return promise so submitting flag works!
    return actions.resetPassword(values.email).then(response => this.handleResponse(response));
  };


  render() {
    const { dataLoading } = this.state;
    

    return (
      <div>

      { dataLoading ? <ComponentLoading /> : 
      <div>
        <Box px={1} className="logoOuterWrap narrowMaxMediumWidthPart">
        <div className="logoWrap">
          <Logo showAppName={true} />
        </div>
        <PageHeading heading={TranslatorUtil.t("Reset password")} />
        </Box>

        <UserResetPasswordForm 
        proceedSubmit={this.handleSubmit} 
        //initialValues={}
      />
      <div className="formLinksWrap">
      <Box px={1} pb={2} className="narrowMaxMediumWidthPart">
      <Alert severity="info">{TranslatorUtil.t("If you think you know the password go back to login below")}</Alert>
      </Box>
      <NavLink className="linkBtn" to={UrlBuilderUtil.getLogin()} >{TranslatorUtil.t("Login")}</NavLink>
      </div>
      </div> }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = dispatch =>
({
  changeFieldValue: function(field, value) {
    dispatch(change(entityFormName, field, value))
  },
  actions: bindActionCreators(
    {
      ...firebaseUserActions,
    },
    dispatch
  )
});


export default withRouter(withSnackbar(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ResetPassword)
));